export default __webpack_public_path__ + "static/media/rus.b2456e91.png";